import UpdateClientForm from '../UpdateClientForm/UpdateClientForm'
import './UpdateClient.css'

export default function UpdateClient({user, client, updateClientPage, toggleNotifications}) {
  return (
    <div className='UpdateClient modal fade' id='updateClientModal' data-bs-keyboard="false" aria-labelledby={`updateClientHeader`}>
      <UpdateClientForm user={user} client={client} updateClientPage={updateClientPage} toggleNotifications={toggleNotifications} />
    </div>
  )
}
